import { render, staticRenderFns } from "./prescriptdetail.vue?vue&type=template&id=bd85da4a&scoped=true"
import script from "./prescriptdetail.vue?vue&type=script&lang=js"
export * from "./prescriptdetail.vue?vue&type=script&lang=js"
import style0 from "./prescriptdetail.vue?vue&type=style&index=0&id=bd85da4a&prod&scoped=true&lang=css"
import style1 from "./prescriptdetail.vue?vue&type=style&index=1&id=bd85da4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd85da4a",
  null
  
)

export default component.exports